import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

const Navbar = () => {
  const [scrolling, setScrolling] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolling(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const navLinks = [
    { name: "About", path: "/", num: "01" },
    { name: "Experience", path: "/experience", num: "02" },
    { name: "Skills", path: "/skills", num: "03" },
    { name: "Projects", path: "/projects", num: "04" },
    { name: "Articles", path: "/blog", num: "05" },
    { name: "Contact", path: "/contact", num: "06" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full transition-all duration-500 z-50 ${
        scrolling
          ? "bg-[#020024]/90 border-b border-gray-800/40"
          : "bg-transparent"
      } backdrop-blur-xl`}
    >
      <div className="max-w-5xl mx-auto flex items-center justify-between px-6 py-4">
        {/* Logo — minimal monospace */}
        <NavLink to="/" className="group flex items-center gap-2" onClick={() => setMenuOpen(false)}>
          <span className="text-sm font-black tracking-tight text-white">SG</span>
          <span className="hidden sm:block text-[10px] font-mono text-gray-700 tracking-widest uppercase">/ portfolio</span>
        </NavLink>

        {/* Desktop Navigation — numbered links */}
        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.num}>
              <NavLink
                to={link.path}
                className={({ isActive }) =>
                  `group relative px-3 py-2 text-sm transition-all duration-300 ${
                    isActive
                      ? "text-white"
                      : "text-gray-600 hover:text-gray-300"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <span className="font-mono text-[9px] text-gray-700 mr-1 align-top">{link.num}</span>
                    <span className="font-medium">{link.name}</span>
                    {/* Active indicator — bottom line */}
                    <span className={`absolute bottom-0.5 left-3 right-3 h-px transition-all duration-300 ${
                      isActive ? "bg-blue-400/60" : "bg-transparent group-hover:bg-gray-700"
                    }`}></span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-gray-400 hover:text-white focus:outline-none z-50 w-9 h-9 flex items-center justify-center transition-colors"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          {menuOpen ? <FiX size={18} /> : <FiMenu size={18} />}
        </button>

        {/* Overlay for mobile menu */}
        {menuOpen && (
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm md:hidden z-40" onClick={() => setMenuOpen(false)} />
        )}

        {/* Mobile Navigation — full-screen editorial */}
        <div
          className={`fixed top-0 right-0 w-72 h-screen bg-[#050520]/98 backdrop-blur-xl border-l border-gray-800/30 flex flex-col justify-center px-8 transition-transform z-50 ${
            menuOpen ? "translate-x-0" : "translate-x-full"
          } ease-[cubic-bezier(0.25,0.46,0.45,0.94)] duration-500 md:hidden`}
        >
          <div className="space-y-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.num}
                to={link.path}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `group flex items-center gap-3 py-3 transition-all duration-300 ${
                    isActive
                      ? "text-white"
                      : "text-gray-600 hover:text-gray-300"
                  }`
                }
              >
                <span className="font-mono text-[10px] text-gray-700 w-5">{link.num}</span>
                <span className="text-lg font-light tracking-wide">{link.name}</span>
              </NavLink>
            ))}
          </div>

          {/* Mobile footer accent */}
          <div className="absolute bottom-8 left-8 right-8">
            <div className="h-px bg-gray-800/40 mb-3"></div>
            <span className="text-[10px] font-mono text-gray-800">shivansh@dev:~$</span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
